const stringHelpers = require('../../olycommon/stringhelpers');

module.exports = function () {
    return stringHelpers.hyphenate;
};



// WEBPACK FOOTER //
// ./src/common/filters/wow-hyphenate-name.js